<p id=logotype-desc>Наша эмблема очень красивая. На ней нарисованы два следа, горы и солнце, а также снизу красуется
  название нашего клуба.</p>
